import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { SectionHead, Reveal } from "./Reveal";

const STEPS = [
  ["Sopralluogo", "Veniamo a vedere l'immobile, ascoltiamo le tue esigenze e prendiamo le misure."],
  ["Progetto e preventivo", "Ricevi un preventivo dettagliato con materiali, tempi e costi definiti."],
  ["Demolizione e impianti", "Apriamo il cantiere: demolizioni, nuove murature e rifacimento impianti."],
  ["Forniture e posa", "Posiamo pavimenti, rivestimenti, serramenti e rubinetteria scelti insieme."],
  ["Arredamento e montaggio", "Montiamo cucina, armadi e mobili su misura scelti in fase di progetto, coordinati con le finiture."],
  ["Consegna delle chiavi", "Finiture, pulizia, verifiche finali e consegna della casa arredata e pronta da vivere."],
];

export const Method = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 80, damping: 25 });

  return (
    <section id="metodo" data-testid="method-section" className="relative bg-[#0d0d0e] py-28 lg:py-40 grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <SectionHead label="Il metodo" title={<>Dalla demolizione <em className="italic text-[#e8c063]">alle chiavi.</em></>}>
            <p className="mt-8 text-base md:text-lg text-[#c9c3b7] leading-relaxed max-w-md">
              Sei passaggi, un unico interlocutore. Sai sempre a chi rivolgerti e a che punto sono i lavori.
            </p>
          </SectionHead>
        </div>
        <div ref={ref} className="lg:col-span-6 lg:col-start-7 relative pl-10 md:pl-16">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-[#d4a73c]/20" />
          <motion.div style={{ scaleY }} className="absolute left-0 top-2 bottom-2 w-px bg-[#d4a73c] origin-top" />
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={0.05} className="relative pb-16 last:pb-0" >
              <span className="absolute -left-10 md:-left-16 top-3 -translate-x-1/2 w-3 h-3 rotate-45 border border-[#d4a73c] bg-[#0d0d0e]" />
              <div data-testid={`method-step-${i}`}>
                <span className="font-display italic text-6xl md:text-7xl text-[#d4a73c]/40 leading-none">0{i + 1}</span>
                <h3 className="mt-2 font-display text-3xl md:text-4xl text-[#f4f1ea]">{t}</h3>
                <p className="mt-3 text-[#c9c3b7] leading-relaxed max-w-md">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
